module.exports = __webpack_public_path__ + "img/MSuite-trang.0b5b2535.svg";